import { useMutation } from 'react-query'
import { AnimalsClient } from '../interactors/clients/AnimalsClient'
import { useAnimalStore } from './AnimalStore'
import { useGlobalSnackbarStore } from './GlobalSnackBarStore'
import { forbiddenErrorMessage } from '../utils/axios'

export const useEditAnimalMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (error: unknown) => void
}) => {
  const globalSnackBarStore = useGlobalSnackbarStore()
  const animalStore = useAnimalStore()

  return useMutation(AnimalsClient.editAnimal, {
    onSuccess: async (data) => {
      globalSnackBarStore.triggerSuccessMessage(`${data.name} modifié !`)
      useAnimalStore.setState((state) => ({
        ...state,
        selectedAnimal: data,
      }))
      await animalStore.refreshSelectedAnimalInBackground()
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: async (error) => {
      console.error(error)
      // A 403 carries a message written for the user, e.g. the free plan's per-animal health follow-up limit.
      globalSnackBarStore.triggerErrorMessage(forbiddenErrorMessage(error) ?? `Une erreur est survenue !`)
      await animalStore.refreshSelectedAnimalInBackground()
      if (onError) {
        onError(error)
      }
    },
  })
}
